import type { TBillingSubscriptionStage } from '@newo/api/gateway';
import type { ReactNode } from 'react';

export type LearnMoreButton = {
    label: string;
    link: string;
    isExternal?: boolean;
};

export type StatusModeItem = {
    title: string;
    message: ReactNode;
    learnMoreButton: LearnMoreButton;
};

const HELP_ARTICLE =
    'https://help.newo.ai/en/articles/13786146-billing-process-guide-for-partners';

const learnMoreButton: LearnMoreButton = {
    label: 'Learn More',
    link: HELP_ARTICLE,
    isExternal: true
};

export const StatusModeContent: Partial<
    Record<TBillingSubscriptionStage | 'temporal', StatusModeItem>
> = {
    development: {
        title: 'Development mode:',
        message: (
            <>
                Your account is currently in the free development stage and has
                certain limitations. Start 14-day free trial to remove the
                restrictions and make your agent public.
            </>
        ),
        learnMoreButton
    },
    trial: {
        title: 'Free trial:',
        message: (
            <>
                You are enjoying a 14-day free trial with full production
                access. Once this period ends, your paid subscription will begin
                automatically.
            </>
        ),
        learnMoreButton
    },
    temporal: {
        title: 'Temporary account:',
        message: (
            <>
                Your agent will be archived soon. Activate free Development mode
                to keep it active.
            </>
        ),
        learnMoreButton
    }
};
